import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    to: '/process',
    label: 'Process'
  }, {
    to: '/showroom',
    label: 'Showroom'
  }, {
    to: '/pricing',
    label: 'Pricing'
  }, {
    to: '/faq',
    label: 'FAQ'
  }];
  return <nav className="sticky top-0 z-50 bg-alabaster/80 backdrop-blur-md border-b-3 border-charcoal px-6 py-1" data-id="element-92">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-93">
        <Link to="/" className="flex items-center gap-2" onClick={() => setIsOpen(false)} data-id="element-94">
          <img src="https://cdn.magicpatterns.com/uploads/28ZTKaKZzKVJqAkn3TE3hV/ChatGPT_Image_May_21,_2026,_07_24_32_PM.png" alt="NK Refacers Logo" className="h-16 md:h-20 w-auto object-contain" data-id="element-95" />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-10 text-sm font-bold uppercase tracking-widest" data-id="element-96">
          {navLinks.map(link => {
          const isActive = location.pathname === link.to;
          return <Link key={link.to} to={link.to} className={`${isActive ? 'text-espresso' : 'text-charcoal'} hover:text-espresso transition-colors relative`} data-id="element-97">
                {link.label}
                {isActive && <motion.div layoutId="nav-underline" className="absolute -bottom-1 left-0 w-full h-0.5 bg-espresso" data-id="element-98" />}
              </Link>;
        })}
          <Link to="/get-quote" className={`${location.pathname === '/get-quote' ? 'bg-espresso' : 'bg-charcoal'} text-alabaster px-6 py-3 hover:bg-espresso transition-colors`} data-id="element-99">
            Get Quote
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-charcoal" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-100">
          {isOpen ? <X size={32} data-id="element-101" /> : <Menu size={32} data-id="element-102" />}
        </button>
      </div>

      {/* Mobile Navigation Overlay */}
      <AnimatePresence data-id="element-103">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="absolute top-full left-0 w-full bg-white border-b-3 border-charcoal shadow-xl md:hidden overflow-hidden" data-id="element-104">
            <div className="flex flex-col p-8 gap-6" data-id="element-105">
              {navLinks.map(link => {
            const isActive = location.pathname === link.to;
            return <Link key={link.to} to={link.to} className={`text-2xl font-bold uppercase tracking-tight ${isActive ? 'text-espresso' : 'text-charcoal'} hover:text-espresso transition-colors`} onClick={() => setIsOpen(false)} data-id="element-106">
                    {link.label}
                  </Link>;
          })}
              <Link to="/get-quote" className={`${location.pathname === '/get-quote' ? 'bg-espresso' : 'bg-charcoal'} text-alabaster py-5 text-center font-bold uppercase tracking-widest hover:bg-espresso transition-colors`} onClick={() => setIsOpen(false)} data-id="element-107">
                Get Quote
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}